import { datadogRum, Site } from '@datadog/browser-rum'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  const isDevOrProd = ['production', 'development'].includes(import.meta.env.MODE)
  const isLocal = runtimeConfig.public.APP_VERSION === 'local'
  // @ts-ignore
  const globalStore = useGlobalStore(nuxtApp.$pinia)

  !isLocal &&
    datadogRum.init({
      applicationId: runtimeConfig.public.DATADOG_APPLICATION_ID,
      clientToken: runtimeConfig.public.DATADOG_CLIENT_TOKEN,
      site: runtimeConfig.public.DATADOG_SITE as Site,
      service: runtimeConfig.public.DATADOG_SERVICE,
      env: import.meta.env.MODE,
      sessionSampleRate: isDevOrProd ? 100 : 0,
      sessionReplaySampleRate: 0,
      trackUserInteractions: isDevOrProd,
      trackResources: isDevOrProd,
      trackLongTasks: isDevOrProd,
      version: runtimeConfig.public.APP_VERSION,
      defaultPrivacyLevel: 'allow',
    })

  datadogRum.setUser({
    id: globalStore.store?.id,
    storeId: globalStore.store?.id,
    storeHandle: globalStore.store?.handle,
    storeName: globalStore.store?.companyName,
    status: globalStore.store.status,
  })

  isDevOrProd && datadogRum.startSessionReplayRecording()
})
